import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Loader from 'router/Loader';

const DashboardPage = Loader(
  lazy(() => import('content/pages/Private/Dashboard')),
);

const dashboardRouter: RouteObject[] = [
  {
    path: 'dashboard',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <DashboardPage />,
      },
    ],
  },
];

export default dashboardRouter;
